/* eslint-disable @typescript-eslint/consistent-type-assertions */

function waitForElement(selector: string, startingPoint = document) {
  return new Promise((resolve) => {
    if (startingPoint.querySelector(selector)) {
      return resolve(startingPoint.querySelector(selector))
    }

    const observer = new MutationObserver(() => {
      if (startingPoint.querySelector(selector)) {
        resolve(startingPoint.querySelector(selector))
        observer.disconnect()
      }
    })

    observer.observe(startingPoint.body ?? startingPoint, {
      childList: true,
      subtree: true,
    })
  })
}

export async function getSource(type: string, parentId: string) {
  switch (type) {
    case 'TaboolaV5': {
      const parent = (await waitForElement('#' + parentId)) as Document
      const item = (await waitForElement('.branding', parent)) as HTMLElement
      const text = item?.innerText || item?.textContent
      return text
    }

    case 'Outbrain': {
      const parent = (await waitForElement('.' + parentId)) as Document
      const item = parent?.querySelector('.ob-rec-source') as HTMLElement
      const fullText = item?.innerText || item?.textContent
      const text = fullText?.split(' | AD')[0]
      return text
    }

    default: {
      return null
    }
  }
}

export const checkHostBrowser = () => {
  const { shift, onelaunch } = getHostApis()
  return Boolean(shift || onelaunch)
}
